export const contactInfoTitle = 'Your contact information';

export {
  contactInfoDescription,
  contactInfoUpdateHelpDescription,
} from '../../../shared/components/contactInfoDescriptions';
